import { Member, MemberApiUpdateMemberRequest, UpdateMemberResponse } from "@vitable/asclepius-api-client-ts"
import { ref, watch } from "vue"
import useAsclepius from "@common/composables/api/asclepius"

export function useUpdateMember() {
  const { getMemberApi, callWithResponse, callResult } = useAsclepius()

  const member = ref<Nullable<Member>>(null)

  async function updateMember(params: MemberApiUpdateMemberRequest): Promise<void> {
    await callWithResponse(() => getMemberApi().updateMember(params))
  }

  watch(callResult, (newResult) => {
    // @ts-ignore
    if (newResult.isSuccess()) {
      // @ts-ignore
      const data: UpdateMemberResponse = newResult.getData()
      member.value = data.member
    }
  })

  return {
    updateMember,
    memberResult: callResult,
    member
  }
}
